import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { LandingPageConfig } from "./entity";

const createCustomFilter = createCustomFilterForEntity<LandingPageConfig>();

export class LandingPageConfigFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<LandingPageConfig>
  >((filters) => filterWithRelationsAndJson(LandingPageConfig)(filters));
}
